import {SEARCH_MIN_CHARS} from 'ff-common';

/**
 * Terme passé à Orama pour le cadencier.
 * En dessous de SEARCH_MIN_CHARS, on n'envoie pas `q` (même seuil que le catalogue).
 */
export function qCadencierPourRecherche(
  q: string | undefined,
): string | undefined {
  if (q === undefined || q.length < SEARCH_MIN_CHARS) {
    return undefined;
  }
  return q;
}
